import React from 'react';
import { Card, Button, ListGroup } from 'react-bootstrap';
import './SchedulePreview.css';
import { apiPaths } from '../../services/apiPath';
import config from '../../services/apiConfig';

const SchedulePreview = ({ selectedEvents, vendorId, weekData, historicalEvents,historicalDaySales }) => {
  console.log("✅ Rendering Schedule Preview", selectedEvents);

  const historical_events = [
    ...(historicalEvents?.lastYear || []).map(event => ({
      event_id: event.event_id,
      name: event.event_name,
      location: event.location,
      start_date: event.start_date,
      end_date: event.end_date,
      year_group: 'Last Year',
      predicted_date: event.predicted_date || null,
      total_sales: event.total_sales,
      profit_estimate_after_payout_stock_and_labor: event.profit_estimate_after_payout_stock_and_labor,
      total_stock_cost_in_dollars: event.total_stock_cost_in_dollars,
      total_wage_cost_for_this_event: event.total_wage_cost_for_this_event,
    })),
    ...(historicalEvents?.last2Years || []).map(event => ({
      event_id: event.event_id,
      name: event.event_name,
      location: event.location,
      start_date: event.start_date,
      end_date: event.end_date,
      year_group: 'Last 2 Years',
      predicted_date: event.predicted_date || null,
      total_sales: event.total_sales,
      profit_estimate_after_payout_stock_and_labor: event.profit_estimate_after_payout_stock_and_labor,
      total_stock_cost_in_dollars: event.total_stock_cost_in_dollars,
      total_wage_cost_for_this_event: event.total_wage_cost_for_this_event,
    })),
    ...(historicalEvents?.last3Years || []).map(event => ({
      event_id: event.event_id,
      name: event.event_name,
      location: event.location,
      start_date: event.start_date,
      end_date: event.end_date,
      year_group: 'Last 3 Years',
      predicted_date: event.predicted_date || null,
      total_sales: event.total_sales,
      profit_estimate_after_payout_stock_and_labor: event.profit_estimate_after_payout_stock_and_labor,
      total_stock_cost_in_dollars: event.total_stock_cost_in_dollars,
      total_wage_cost_for_this_event: event.total_wage_cost_for_this_event,
    }))
  ];

  const handleConfirmSchedule = async () => {
    debugger;
    const payload = {
      query_type: 'draft_schedule_events',
      vendor_id: vendorId,
      week_number: weekData.week,
      events: selectedEvents.map(event => ({
        name: event.event_name,
        location: event.location,
        predicted_date: event.predicted_date || null,
      })),
      historical_events: historical_events,
      historicalEventsDates: historicalEvents,
      historicalRawDaySales: historicalDaySales
      
    };

    try {
      const response = await fetch(config.BASE_URI + apiPaths.adminData, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          payload: {
            body: payload
          }
        }),
      });

      const data = await response.json();
      if (data.success) {
        alert(`✅ Successfully drafted ${selectedEvents.length} event(s)`);
      } else {
        alert('⚠️ Failed to draft schedule');
      }
    } catch (err) {
      console.error("❌ Draft schedule failed:", err);
      alert('Error while drafting schedule: ' + err);
    }
  };

  if (!selectedEvents || selectedEvents.length === 0) {
    return <p className="text-muted mt-3">⚠️ No draft events selected for this week.</p>;
  }

  return (
    <Card className="schedule-preview shadow-sm mt-4">
      <Card.Body>
        <Card.Title className="text-primary mb-3">
          📋 Draft Schedule (Week {weekData.week}) — {selectedEvents.length} Event{selectedEvents.length > 1 ? 's' : ''}
        </Card.Title>

        <ListGroup variant="flush" className="rounded">
          {selectedEvents.map((event) => (
            <ListGroup.Item key={event.id} className="d-flex justify-content-between align-items-center">
              <span>
                <strong>{event.event_name}</strong> – {event.location}
                {event.predicted_date && (
                  <span className="ms-2 text-muted">📅 {event.predicted_date}</span>
                )}
              </span>
            </ListGroup.Item>
          ))}
        </ListGroup>

        <div className="text-end mt-4">
          <Button
            variant="success"
            onClick={handleConfirmSchedule}
            disabled={selectedEvents.length === 0}
            className="px-4 py-2"
          >
            ✅ Confirm Draft & Draft Schedule Events
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SchedulePreview;
